import { Contract } from '@/modules/Contract/types'
import { useEffect } from 'react'
import { Control, Path, useWatch } from 'react-hook-form'

interface useCommitmentPriceTotalProps {
    control: Control<Contract>
    name: string
    index: number
    setValue: (name: Path<Contract>, value: any) => void
}

const useCommitmentPriceTotal = ({
    control,
    name,
    index,
    setValue,
}: useCommitmentPriceTotalProps) => {
    const service_configoptions = useWatch({
        control: control,
        name: `${name}` as Path<Contract>,
    })

    const commitment_value = useWatch({
        control: control,
        name: `${name}.[${index}].commitment_value` as Path<Contract>,
    })

    const commitment_price_per_unit = useWatch({
        control: control,
        name: `${name}.[${index}].commitment_price_per_unit` as Path<Contract>,
    })

    useEffect(() => {
        if (service_configoptions?.length === 0) {
            return
        }

        setValue(
            `${name}.[${index}].commitment_price_total` as Path<Contract>,
            (commitment_value || 0) * (commitment_price_per_unit || 0) || 0
        )
    }, [commitment_value, commitment_price_per_unit])
}

export default useCommitmentPriceTotal
